// extracted by mini-css-extract-plugin
export var dividerLine = "_5d-0";
export var errorBackground = "_5d-1";